import { render, staticRenderFns } from "./special_focus_records.vue?vue&type=template&id=281aaed6&scoped=true&"
import script from "./special_focus_records.vue?vue&type=script&lang=js&"
export * from "./special_focus_records.vue?vue&type=script&lang=js&"
import style0 from "./special_focus_records.vue?vue&type=style&index=0&id=281aaed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281aaed6",
  null
  
)

export default component.exports